/* SOCIALFUEL buy box: flavour dropdown + review pull-quote */
(function () {
  // Variant pills -> native dropdown. The theme's pills and radios stay in the page (hidden),
  // so variant switching, Vitals, Bold and the flavour-image filter keep working off them.
  // A 'how many of X' option inside a bundle (e.g. 'Carbohydrates Quantity' 1 / 2) reads like a second quantity
  // field. It is renamed to the item ('Carbohydrates'), each choice says what you get and what it adds to the
  // price ('2 x 1kg bags (+$50)'), and it sits after the flavour pickers. Display only: the option itself is untouched.
  var priceDiffs = null;
  function qtyLabel(group, select) {
    var name = group.getAttribute('option-picker-name') || '';
    var opts = Array.prototype.slice.call(select.options);
    if (!/quantity$/i.test(name) || !opts.every(function (o) { return /^\d+$/.test(o.dataset.sfVal || ''); })) return;
    group.style.order = '9';
    var title = name.replace(/\s*quantity$/i, '');
    var label = group.querySelector('.product-variant-picker__option-label');
    if (label && label.textContent.trim() !== title) label.textContent = title;
    var unit = /carbohydrate/i.test(name) ? ' × 1kg bag' : '';
    opts.forEach(function (o) {
      var n = +o.dataset.sfVal;
      var diff = priceDiffs && priceDiffs[name] && priceDiffs[name][o.dataset.sfVal];
      var text = unit ? n + unit + (n > 1 ? 's' : '') : o.dataset.sfVal;
      if (diff) text += ' (+$' + (diff % 100 ? (diff / 100).toFixed(2) : diff / 100) + ')';
      if (o.dataset.sfSold) text += ' (sold out)';
      if (o.textContent !== text) o.textContent = text;
    });
  }
  function loadDiffs() {
    var path = (location.pathname.match(/\/products\/[^\/?#]+/) || [])[0];
    if (!path || !document.querySelector('.product__info [option-picker-name$="Quantity"]')) return;
    fetch(path + '.js').then(function (r) { return r.json(); }).then(function (p) {
      // per option name: what each value adds to the price of the cheapest variant with the first value
      priceDiffs = {};
      p.options.forEach(function (opt, i) {
        var min = {};
        p.variants.forEach(function (v) { var val = v.options[i]; if (!(val in min) || v.price < min[val]) min[val] = v.price; });
        var d = priceDiffs[opt.name] = {};
        opt.values.forEach(function (val) { d[val] = min[val] - min[opt.values[0]]; });
      });
      document.querySelectorAll('.product__info variant-picker').forEach(function (picker) { build(picker); });
    }).catch(function () {});
  }
  function build(picker) {
    picker.querySelectorAll('[data-variant-picker-option-labels]').forEach(function (group) {
      var pills = group.querySelectorAll('label.pill[for]');
      if (pills.length < 2) return;
      var list = group.querySelector('.product-variant-picker__pill-list');
      if (list) list.style.display = 'none';
      var existing = group.querySelector('select.sf-variant-select');
      if (existing) {
        // keep the dropdown in sync after the theme re-renders the pills
        var sel = group.querySelector('label.pill.selected');
        if (sel) existing.value = sel.getAttribute('for');
        qtyLabel(group, existing);
        return;
      }
      var select = document.createElement('select');
      select.className = 'sf-variant-select';
      select.setAttribute('aria-label', group.getAttribute('option-picker-name') || 'Option');
      pills.forEach(function (pill) {
        var o = document.createElement('option');
        o.value = pill.getAttribute('for');
        o.textContent = pill.innerText.replace(/\s+/g, ' ').trim();
        o.dataset.sfVal = o.textContent;
        var radio = document.getElementById(o.value);
        if (pill.classList.contains('disabled') || (radio && radio.disabled)) { o.textContent += ' (sold out)'; o.dataset.sfSold = '1'; }
        if (pill.classList.contains('selected') || (radio && radio.checked)) o.selected = true;
        select.appendChild(o);
      });
      select.addEventListener('change', function () {
        var pill = group.querySelector('label.pill[for="' + CSS.escape(select.value) + '"]');
        if (pill) pill.click();
      });
      group.classList.add('sf-has-select');
      (list ? list.parentNode : group).insertBefore(select, list || null);
      qtyLabel(group, select);
    });
  }
  function init() {
    document.querySelectorAll('.product__info variant-picker').forEach(function (picker) {
      build(picker);
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { build(picker); }, 30); })
        .observe(picker, { childList: true, subtree: true });
    });
    loadDiffs();
  }

  // Review pull-quote from the live Klaviyo reviews on this page
  function quote() {
    var box = document.querySelector('[data-sf-quote]');
    if (!box) return;
    var tries = 0;
    (function fill() {
      var pick = null;
      document.querySelectorAll('.kl_reviews__review_item').forEach(function (item) {
        if (pick) return;
        var t = item.querySelector('.kl_reviews__review__content');
        var text = t ? t.innerText.trim() : '';
        if (text.length >= 60 && text.length <= 240) pick = { item: item, text: text };
      });
      if (!pick) { if (tries++ < 40) setTimeout(fill, 500); return; }
      var who = pick.item.querySelector('.kl_reviews__review__author');
      var stars = pick.item.querySelector('.kl_reviews__stars_badge');
      var starBox = box.querySelector('.sf-quote__stars');
      if (stars && starBox) {
        // Copy the stars with fresh gradient ids: duplicate ids break the original review's stars when the quote is hidden
        var c = stars.cloneNode(true);
        c.querySelectorAll('[id]').forEach(function (el) {
          var o = el.id, n = o + '-sfq';
          el.id = n;
          c.querySelectorAll('[fill="url(#' + o + ')"]').forEach(function (p) { p.setAttribute('fill', 'url(#' + n + ')'); });
        });
        starBox.innerHTML = '';
        starBox.appendChild(c);
      }
      box.querySelector('[data-sf-quote-text]').textContent = '“' + pick.text + '”';
      var name = who ? who.innerText.replace(/verified\s*buyer/ig, '').replace(/\s+/g, ' ').trim() : '';
      var whoEl = box.querySelector('[data-sf-quote-who]');
      whoEl.innerHTML = '';
      if (name) { var n = document.createElement('span'); n.textContent = name; whoEl.appendChild(n); }
      var v = document.createElement('span');
      v.className = 'sf-quote__verified';
      var tick = pick.item.querySelector('.kl_reviews__review__verified svg');
      if (tick) v.appendChild(tick.cloneNode(true));
      v.appendChild(document.createTextNode('Verified buyer'));
      whoEl.appendChild(v);
      box.hidden = false;
    })();
  }


  // Star rating under the title: "(107 reviews)"
  function bracketCount() {
    var tries = 0;
    (function run() {
      var l = document.querySelector('.product__info .kl_reviews__star_rating_widget__label');
      if (!l) { if (tries++ < 40) setTimeout(run, 250); return; }
      var t = l.textContent.trim();
      if (t && t.charAt(0) !== '(') l.textContent = '(' + t + ')';
    })();
  }

  // Directions: an icon for each use-case label
  var ICONS = {
    health: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    recovery: '<path d="M20 12a8 8 0 1 1-2.3-5.6"/><path d="M20 4v4h-4"/><path d="M9 12.5l2 2 4-4"/>',
    muscle: '<path d="M6.5 6.5v11M17.5 6.5v11M3.5 9v6M20.5 9v6M6.5 12h11"/>',
    energy: '<path d="M13 3L5 13h6l-1 8 8-10h-6l1-8z"/>',
    hydration: '<path d="M12 3s6 6.4 6 11a6 6 0 0 1-12 0c0-4.6 6-11 6-11z"/>',
    time: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    rest: '<path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/>',
    scoop: '<path d="M3.5 9.5h10v3a5 5 0 0 1-10 0v-3z"/><path d="M13.5 11h7"/>',
    cool: '<path d="M12 3L12 21M19.8 7.5L4.2 16.5M19.8 16.5L4.2 7.5"/><path d="M9.8 4.2L12 6.4L14.2 4.2M17.7 6.2L16.8 9.2L19.9 10M19.9 14L16.8 14.8L17.7 17.8M14.2 19.8L12 17.6L9.8 19.8M6.3 17.8L7.2 14.8L4.1 14M4.1 10L7.2 9.2L6.3 6.2"/>',
    warm: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M18.7 5.3l-1.8 1.8M7.1 16.9l-1.8 1.8"/>',
    burn: '<path d="M12 21a6 6 0 0 0 6-6c0-3-2-4.5-3-7.5-.6 1.4-1.5 2.3-2.5 3C12 8 11.5 5.5 9.5 3 9.5 6.5 6 8.5 6 15a6 6 0 0 0 6 6z"/>',
    dot: '<circle cx="12" cy="12" r="3"/>'
  };
  function pickIcon(label) {
    var s = label.toLowerCase();
    // cool conditions get the snowflake and warm conditions the sun;
    // rest days get the moon, post-workout the dumbbell, the serving size a scoop; general health keeps the heart
    if (/\b(cool|cold)\b/.test(s)) return 'cool';
    if (/\b(warm|hot|heat)\b/.test(s)) return 'warm';
    if (/non[- ]?training|rest day/.test(s)) return 'rest';
    if (/post[- ]?workout/.test(s)) return 'muscle';
    if (/serve|serving|scoop/.test(s)) return 'scoop';
    if (/muscle|strength|growth|bulk|mass/.test(s)) return 'muscle';
    if (/fat loss|lean/.test(s)) return 'burn';
    if (/loading/.test(s)) return 'muscle';
    if (/maintenance/.test(s)) return 'recovery';
    if (/running|cycling|triathlon/.test(s)) return 'energy';
    if (/recover/.test(s)) return 'recovery';
    if (/health|wellness|daily|general/.test(s)) return 'health';
    if (/hydrat|endurance|sweat|electrolyte/.test(s)) return 'hydration';
    if (/energy|pre|before|focus|perform/.test(s)) return 'energy';
    if (/during|after|post|morning|night|time/.test(s)) return 'time';
    return 'dot';
  }
  function iconFor(label) {
    return '<span class="sf-pdp__dir-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + ICONS[pickIcon(label)] + '</svg></span>';
  }

  // Directions copy arrives as 'Label: text'. The label is styled as a heading, so drop the stray colon.
  function tidyDirections() {
    document.querySelectorAll('.sf-pdp__directions strong').forEach(function (s) {
      var n = s.nextSibling;
      if (n && n.nodeType === 3) n.textContent = n.textContent.replace(/^\s*:\s*/, '');
      var label = s.textContent.replace(/\s*:\s*$/, '').trim();
      if (s.querySelector('.sf-pdp__dir-icon')) return;
      s.innerHTML = iconFor(label) + '<span></span>';
      s.lastChild.textContent = label;
    });
  }

  // Trust strip: always one line. Shrink the type until it fits the buy-box width.
  // The sizing is worked out on an invisible copy, then applied in one go, so the real strip never
  // shows the in-between sizes (iPhone Safari fires resize while scrolling, which made it flash).
  function fitTrust() {
    var ul = document.querySelector('.product__info .sf-trust') || document.querySelector('.sf-trust');
    if (!ul || !ul.clientWidth) return;
    var t = ul.cloneNode(true);
    t.setAttribute('aria-hidden', 'true');
    t.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;width:' + ul.clientWidth + 'px';
    ul.parentNode.appendChild(t);
    var icons = t.querySelectorAll('.sf-icon'), size = 12, gap = '', iconsOn = true;
    function over() { return t.scrollWidth > t.clientWidth + 1; }
    function tryFit(min) {
      size = 12;
      t.style.fontSize = size + 'px';
      while (over() && size > min) { size -= 0.25; t.style.fontSize = size + 'px'; }
      return !over();
    }
    icons.forEach(function (i) { i.style.display = 'block'; });
    if (!tryFit(10)) {
      gap = '8px'; t.style.gap = gap;
      if (!tryFit(9)) {
        iconsOn = false;
        icons.forEach(function (i) { i.style.display = 'none'; });
        tryFit(8);
      }
    }
    t.remove();
    ul.style.fontSize = size + 'px';
    ul.style.gap = gap;
    ul.querySelectorAll('.sf-icon').forEach(function (i) { i.style.display = iconsOn ? 'block' : 'none'; });
  }
  function syncNote() {
    var ul = document.querySelector('.product__info .sf-trust') || document.querySelector('.sf-trust'), note = document.querySelector('.sf-trust-note');
    if (ul && note) note.style.fontSize = ul.style.fontSize;
  }

  // Mobile tabs: switch between the full story sections (CSS only hides the inactive ones on phones)
  function tabs() {
    document.querySelectorAll('[data-sf-tabs]').forEach(function (box) {
      var btns = box.querySelectorAll('[data-sf-tab]');
      function show(name) {
        btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-sf-tab') === name ? 'true' : 'false'); });
        box.querySelectorAll('[data-sf-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-sf-panel') === name); });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-sf-tab')); }); });
      if (btns.length) show(btns[0].getAttribute('data-sf-tab'));
    });
  }
  // Multi-buy tiers: Buy 1 is the default. Vitals re-renders (and clears the choice) when the flavour changes,
  // so put back whatever tier the customer last picked.
  var wantedTier = '1';
  // Subscribe and Save selected? Returns its % off (Bold's '(Save 10%)'), or 0 for one-time.
  // Multi-buy savings don't apply to subscriptions, so the tiers then show the subscription price instead.
  function subPercent() {
    var box = document.querySelector('.product__info .bsub-widget');
    var group = box && box.querySelector('.bsub-widget__group[data-bsub-selling-plan-group]');
    var input = group && group.querySelector('input');
    if (!input || !input.checked) return 0;
    var s = group.querySelector('.bsub-widget__group-discount-summary');
    return s ? parseFloat(s.textContent.replace(/[^0-9.]/g, '')) || 0 : 0;
  }
  // Show each tier's price per unit ('$70.30 each'); the pack total stays underneath
  function perUnit(w) {
    var pct = subPercent();
    w.classList.toggle('sf-sub', pct > 0);
    w.querySelectorAll('[data-vtl-el="tier-label"]').forEach(function (l) {
      var m = l.id.match(/-tier-(\d+)-/);
      var tot = l.querySelector('.Vtl-NewVolumeDiscountRadio__TotalDiscountedPrice');
      var full = l.querySelector('.Vtl-NewVolumeDiscountRadio__TotalPrice');
      var col = l.querySelector('.Vtl-NewVolumeDiscountRadio__PriceCol');
      if (!m || !tot || !col) return;
      var qty = +m[1];
      var txt = tot.textContent.trim();
      // currency symbol only: Vitals prefixes a screen-reader 'Sale price ' label
      var cur = (txt.match(/([^\d\s]*)\s*[\d.,]+\s*$/) || ['', ''])[1];
      var n = parseFloat(txt.replace(/[^0-9.]/g, ''));
      if (pct && n) {
        // subscription price per unit = full price less Bold's %, same rounding as the cart
        // (Buy 1 has no discount, so it has no separate full-price element)
        var base = full ? parseFloat(full.textContent.replace(/[^0-9.]/g, '')) : n;
        var unit = Math.round(base / qty * (100 - pct)) / 100;
        var sub = col.querySelector('.sf-tier-subtotal');
        if (!sub) { sub = document.createElement('span'); sub.className = 'sf-tier-subtotal'; col.appendChild(sub); }
        var subLabel = cur + (unit * qty).toFixed(2) + ' total';
        if (sub.textContent !== subLabel) sub.textContent = subLabel;
        n = unit * qty;
      }
      if (!n) return;
      // pack total for the buttons (the cards themselves only show the price per unit)
      var total = cur + n.toFixed(2);
      if (l.dataset.sfTotal !== total) l.dataset.sfTotal = total;
      var label = cur + (n / qty).toFixed(2) + ' each';
      var e = col.querySelector('.sf-tier-each');
      if (!e) { e = document.createElement('span'); e.className = 'sf-tier-each'; col.insertBefore(e, col.firstChild); }
      if (e.textContent !== label) e.textContent = label;
    });
  }
  // Subscribe option wording, on one line. Buy 1: 'Subscribe and Save 10%' (Bold's own % folded into the name).
  // A multi-buy tier (any quantity above 1): multi-buy savings don't apply to subscriptions, so it reads just
  // 'Subscribe'. Works off the selected quantity, so it follows whatever tiers are set in Vitals.
  function subWording(multi) {
    var info = document.querySelector('.product__info');
    var group = info && info.querySelector('.bsub-widget__group[data-bsub-selling-plan-group]');
    var name = group && group.querySelector('.bsub-widget__text > span');
    if (!name) return;
    if (!name.dataset.sfLabel) name.dataset.sfLabel = name.textContent.trim();
    var sum = group.querySelector('.bsub-widget__group-discount-summary');
    var pct = sum ? parseFloat(sum.textContent.replace(/[^0-9.]/g, '')) : 0;
    var label = multi ? 'Subscribe' : name.dataset.sfLabel + (pct ? ' ' + pct + '%' : '');
    if (name.textContent !== label) name.textContent = label;
    // delivery options read '4 Weeks', never '4 Weeks (10% off)': the saving is stated once, in the name above
    info.querySelectorAll('.bsub-widget__main-text').forEach(function (t) {
      var text = t.textContent.replace(/\s*\([^)]*off\)/i, '');
      if (t.textContent !== text) t.textContent = text;
    });
  }
  // The order total lives on the two buttons: on hover it slides in from the right after the label
  // ('Add to cart — $199.80') and it is always shown on touch screens. Products without quantity tiers use price x quantity.
  function btnTotal() {
    var info = document.querySelector('.product__info');
    if (!info) return;
    var total = '';
    var tier = info.querySelector('[data-vtl-el="tier-label"][aria-checked="true"]');
    if (tier) total = tier.dataset.sfTotal || '';
    else if (!info.querySelector('.vtl-ub-vd-widget')) {
      var price = info.querySelector('.block-price');
      var m = price && price.innerText.match(/([^\d\s]*)\s*([\d,]+\.\d{2})/);
      var q = info.querySelector('[name="quantity"]');
      if (m) total = m[1] + (parseFloat(m[2].replace(/,/g, '')) * (q ? +q.value || 1 : 1)).toFixed(2);
    }
    info.querySelectorAll('.product-form__btn, .sf-buy-now').forEach(function (btn) {
      var span = btn.querySelector('.sf-btn-total');
      var text = total && !btn.disabled ? '— ' + total : '';
      if (!span) {
        if (!text) return;
        span = document.createElement('span');
        span.className = 'sf-btn-total';
        span.setAttribute('aria-hidden', 'true');
        btn.appendChild(span);
      }
      if (span.textContent !== text) span.textContent = text;
      if (span.hidden !== !text) span.hidden = !text;
    });
  }
  function keepTier() { tierSync(); btnTotal(); }
  function tierSync() {
    var w = document.querySelector('.product__info .vtl-ub-vd-widget');
    if (!w) { subWording(false); return; }
    perUnit(w);
    var current = w.querySelector('[data-vtl-el="tier-label"][aria-checked="true"]');
    var m = current && current.id.match(/-tier-(\d+)-/);
    if (m) { wantedTier = m[1]; subWording(+m[1] > 1); return; }
    var labels = w.querySelectorAll('[data-vtl-el="tier-label"]');
    if (!labels.length) return;
    var pick = w.querySelector('[data-vtl-el="tier-label"][id*="-tier-' + wantedTier + '-"]') || labels[0];
    pick.click();
  }
  function watchTiers() {
    var info = document.querySelector('.product__info');
    if (!info) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(keepTier, 60); })
      .observe(info, { childList: true, subtree: true });
    // one-time <-> subscribe switches the tier prices
    info.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.bsub-widget')) { clearTimeout(t); t = setTimeout(keepTier, 60); }
    });
    // picking a tier updates the Subscribe wording
    info.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-vtl-el="tier-label"], .product-quantity__wrap')) { clearTimeout(t); t = setTimeout(keepTier, 120); }
    });
    keepTier();
  }

  // Afterpay line on tablets (750-1199px), where the buy box is narrow: 'with [Afterpay]' drops to its own line
  // so nothing is cut off. The widget keeps its text in a shadow root, so the break and its rule go in there.
  function afterpayBreak() {
    var tries = 0;
    (function run() {
      var p = document.querySelector('.product__info afterpay-placement, .product__info square-placement');
      var root = p && p.shadowRoot;
      if (!root || !root.querySelector('.afterpay-main-text strong')) { if (tries++ < 40) setTimeout(run, 500); return; }
      function add() {
        if (!root.querySelector('style[data-sf]')) {
          var st = document.createElement('style');
          st.setAttribute('data-sf', '');
          st.textContent = '@media (max-width:749px),(min-width:1200px){.sf-br{display:none}}' +
            '@media (min-width:750px) and (max-width:1199px){.afterpay-paragraph{white-space:normal!important}}';
          root.appendChild(st);
        }
        var t = root.querySelector('.afterpay-main-text'), price = t && t.querySelector('strong');
        if (!price || t.querySelector('.sf-br')) return;
        var br = document.createElement('br');
        br.className = 'sf-br';
        price.after(br);
      }
      add();
      // the widget re-renders when the price changes (flavour or quantity)
      new MutationObserver(add).observe(root, { childList: true, subtree: true });
    })();
  }

  function fitAll() { fitTrust(); syncNote(); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  window.addEventListener('load', fitAll);
  // only re-fit when the width changes: iPhone Safari resizes the height while scrolling (toolbar in/out)
  var fitW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === fitW) return;
    fitW = window.innerWidth;
    clearTimeout(window.sfFitT); window.sfFitT = setTimeout(fitAll, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); quote(); tabs(); tidyDirections(); bracketCount(); fitAll(); watchTiers(); afterpayBreak(); });
  } else { init(); quote(); tabs(); tidyDirections(); bracketCount(); fitAll(); watchTiers(); afterpayBreak(); }
})();
